import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import styles from "../referral-ime-summary/ReferralImeSummary.Styles";
import Moment from 'moment';
import { EmptyDataLabel } from '../../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import { ReferralScheduleStatusTypesEnum } from '../../../../../support/enums/ReferralScheduleStatusTypesEnum';
import { ReferralOverviewTcmDataModel } from '../../../../../data-models/ReferralOverviewTcm.DataModel';
import ReferralScheduleStatusTypeEntity from '../../../../../entities/ReferralScheduleStatusType.Entity';
import TcmCoverLetterEntity from "../../../../../entities/tcm/TcmCoverLetter.Entity";
import TcmTelephonicCaseManagementEntity from "../../../../../entities/tcm/TcmTelephonicCaseManagement.Entity";

interface IReferralTcmSummaryProps {
    referralOverviewTcmDataModel: ReferralOverviewTcmDataModel;
    scheduleStatusTypes: Array<ReferralScheduleStatusTypeEntity>;
    coverLetter: TcmCoverLetterEntity;
    tcmTelephonicCaseManagement?: TcmTelephonicCaseManagementEntity;
}

export const ReferralTcmSummary: FunctionComponent<IReferralTcmSummaryProps> = (props: IReferralTcmSummaryProps) => {
    const classes = styles();

    // Extracted logic for Claimant Attended
    let claimantAttendedLabel = '';
    const scheduleStatusTypeId = props.referralOverviewTcmDataModel?.schedule?.referralScheduleStatusTypeId;
    if (scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.Completed) {
        claimantAttendedLabel = 'Yes';
    } else if (
        scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.ClaimantNotAttended ||
        scheduleStatusTypeId === ReferralScheduleStatusTypesEnum.UnableToExamine
    ) {
        claimantAttendedLabel = 'No';
    }

    const getScheduleStatusLabel = (): string => {
        const statusId = props.referralOverviewTcmDataModel.schedule?.referralScheduleStatusTypeId;
        if (!statusId || !props.scheduleStatusTypes?.length) return '';
    
        return props.scheduleStatusTypes
            .find(x => x.referralScheduleStatusTypeId === statusId)
            ?.referralScheduleStatusTypeLabel || '';
    }

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                aria-controls="panel1a-content"
                id="tcm-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>TCM</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {
                    props.referralOverviewTcmDataModel ?
                        <Grid container spacing={3} className={classes.gridContainer}>
                            <Grid xs={12} item container >
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.dataLabel}>Schedule Status</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {getScheduleStatusLabel()}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.dataLabel}>Schedule Date & Time</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>{props.referralOverviewTcmDataModel.schedule?.scheduledDate ? Moment(props.referralOverviewTcmDataModel.schedule.scheduledDate).format('MM/DD/YYYY') + ' at ' + Moment(props.referralOverviewTcmDataModel.schedule.scheduledDate).format('HH:mm'): ''}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Claimant Verified They Will Attend</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>{props.referralOverviewTcmDataModel.schedule?.attendanceVerifiedDate ? 'Yes - ' + Moment(props.referralOverviewTcmDataModel.schedule.attendanceVerifiedDate).format('MM/DD/YYYY') : 'No'}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Claimant Attended</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {claimantAttendedLabel}                    
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2" className={classes.dataLabel}>Rush Request</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>
                                        {props.tcmTelephonicCaseManagement?.rushRequest ? 'Yes' : 'No'}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid xs={12} item container >
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.dataLabel}>Cover Letter</Typography>
                                    <Typography variant="subtitle2" className={classes.blackFont}>{props.coverLetter?.isCoverLetterRequired ? 'Yes' : 'No'}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body2" className={classes.dataLabel}>Nurse Summary</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralOverviewTcmDataModel.note?.nurseSummary}</Typography>
                            </Grid>
                        </Grid>
                        :
                        <EmptyDataLabel></EmptyDataLabel>
                }
            </AccordionDetails>
        </Accordion>
    );
}
